var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2857 16.8564H13.7143C12.7675 16.8564 12 17.624 12 18.5707V23.7136C12 24.6604 12.7675 25.4279 13.7143 25.4279H22.2857C23.2325 25.4279 24 24.6604 24 23.7136V18.5707C24 17.624 23.2325 16.8564 22.2857 16.8564Z",
    stroke: "#3D423F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 21.9994C18.4732 21.9994 18.857 21.6157 18.857 21.1423C18.857 20.6689 18.4732 20.2852 17.9998 20.2852C17.5265 20.2852 17.1427 20.6689 17.1427 21.1423C17.1427 21.6157 17.5265 21.9994 17.9998 21.9994Z",
    stroke: "#3D423F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5716 16.8571V13.4286C14.5716 12.5193 14.9328 11.6472 15.5758 11.0042C16.2188 10.3612 17.0909 10 18.0002 10C18.9095 10 19.7815 10.3612 20.4245 11.0042C21.0675 11.6472 21.4287 12.5193 21.4287 13.4286V16.8571",
    stroke: "#3D423F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockRounded);
export default __webpack_public_path__ + "static/media/block-rounded.c8a7a967324021002626e1ad7c72842f.svg";
export { ForwardRef as ReactComponent };